import IconChevronDown from "@tabler/icons-react/dist/esm/icons/IconChevronDown.mjs";
import IconChevronUp from "@tabler/icons-react/dist/esm/icons/IconChevronUp.mjs";
import IconSelector from "@tabler/icons-react/dist/esm/icons/IconSelector.mjs";
import { SORT_DIRECTION } from "../../utils/vars";

function SortIcon({ col, sort }) {
  if (sort.type !== col) return <IconSelector size={13} />;
  return sort.direction === SORT_DIRECTION.ASC ? (
    <IconChevronUp size={13} />
  ) : (
    <IconChevronDown size={13} />
  );
}

export default SortIcon;
